import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { NavLink } from 'react-router-dom'
import { DashboeadMenuArrow, DashboardMenuArrowMobile } from 'media/icons'
import { StyledMenuItem } from './styled'

const MenuItem = ({ label, sub_label = '', link, icon: Icon, onClick }) => {
	const [t] = useTranslation()
	const commonProps = {
		activeClassName: 'is-active'
	}
	return (
		<>
			<NavLink
				{...commonProps}
				to={`/${link}`}
				exact
				onClick={ onClick }
				activeClassName='menu-item-active'
			>
				<div
					className='item_wrapper'
				>
					<StyledMenuItem>
						<div className='icon_wrapper'>
							<Icon />
						</div>
						<div className='link-text'>
							<span>{t(label)}</span>
							{sub_label && <p>{t(sub_label)}</p>}
						</div>
						<div className='arrow tablet_arrow'>
							<DashboeadMenuArrow />
						</div>
						<div className='arrow mobile_arrow'>
							<DashboardMenuArrowMobile />
						</div>
					</StyledMenuItem>
				</div>
			</NavLink>
		</>
	)
}

const { string, func, any } = PropTypes
MenuItem.propTypes = {
	label: string.isRequired,
	link: string.isRequired,
	icon: any,
	onClick: func
}

export default memo(MenuItem)
